<template>
  <Suspense>
    <transition mode="out-in" name="fade">
      <div class="layout-transitions" :key="layout">
        <component v-bind:is="layout" />
      </div>
    </transition>
  </Suspense>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();

const layout = computed(() => {
  return route.meta.layout;
});
</script>
